// ABOUTME: Left and Right arrow keys browse a carousel while its screen is up, as ReadingCarousel does for its own arrows.
// ABOUTME: Refs keep the window listener attached once for the life of the screen instead of on every render.

import { useEffect, useRef } from 'react';

export function useCarouselKeys(prev: () => void, next: () => void) {
  const prevRef = useRef(prev);
  const nextRef = useRef(next);
  useEffect(() => {
    prevRef.current = prev;
    nextRef.current = next;
  });
  useEffect(() => {
    function handleKeyDown(event: KeyboardEvent) {
      if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
      // A dialog (the leave confirmation) owns the arrow keys while it is open.
      if ((event.target as Element | null)?.closest?.('[role="dialog"]')) return;
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        prevRef.current();
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        nextRef.current();
      }
    }
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);
}
